module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-nav', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.previousDash
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n          ")], 1)], 1), _vm._v(" "), _c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("Reports")])], 1), _vm._v(" "), _c('b-card', {
    staticClass: "formCard"
  }, [_c('b-card-text', [_c('div', {
    staticClass: "gutr"
  }, [_c('b-card', {
    staticClass: "gutr",
    attrs: {
      "no-body": ""
    }
  }, [_c('b-tabs', {
    attrs: {
      "card": ""
    }
  }, [_c('b-tab', {
    attrs: {
      "disabled": ""
    }
  }), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Transportation"
    }
  }, [(_vm.$sessionsStorage.get('designation') == 'Admin' && _vm.$sessionsStorage.get('userLevel') == '1') ? _c('div', [_c('div', {
    staticClass: "page-header"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('date-picker', {
    attrs: {
      "range": "",
      "lang": _vm.langTPT,
      "format": "YYYY-MM-DD",
      "confirm": ""
    },
    on: {
      "change": _vm.onConfirmDateRangeTPT
    },
    model: {
      value: (_vm.searchModal.dateRangeTPT),
      callback: function($$v) {
        _vm.$set(_vm.searchModal, "dateRangeTPT", $$v)
      },
      expression: "searchModal.dateRangeTPT"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "btn btn-warning btn-icon text-white mr-2",
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "id": "daterange-btn",
      "data-toggle": "tooltip",
      "title": "",
      "data-placement": "bottom",
      "data-original-title": "Calendar"
    },
    on: {
      "click": function($event) {
        _vm.onDownloadPDF('3')
      }
    }
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-file-pdf-o"
  })])]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-warning btn-icon text-white mr-2",
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "id": "daterange-btn",
      "data-toggle": "tooltip",
      "title": "",
      "data-placement": "bottom",
      "data-original-title": "Calendar"
    },
    on: {
      "click": function($event) {
        _vm.onDownloadExcel('3')
      }
    }
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-file-excel-o"
  })])])], 1)]), _vm._v(" "), _c('b-table', {
    attrs: {
      "responsive:true": "",
      "items": _vm.tptSearchData,
      "fields": _vm.fieldsTPT,
      "per-page": _vm.perPageTPT,
      "sort-by": _vm.sortByTPT,
      "sort-desc": _vm.sortDescTPT,
      "sort-direction": _vm.sortDirectionTPT
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortByTPT = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDescTPT = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "clientName",
      fn: function(row1) {
        return [_c('h6', [_c('b-badge', {
          attrs: {
            "variant": "light"
          }
        }, [_vm._v(_vm._s(row1.item.clientName))])], 1), _vm._v("\n                        Invoice No :\n                        " + _vm._s(row1.item.invoiceSeries) + "\n                        "), _c('br'), _vm._v("\n                        Invoice Date :\n                        " + _vm._s(_vm._f("moment")(row1.item.loginTime)) + "\n                      ")]
      }
    }, {
      key: "multipleContainerType",
      fn: function(row5) {
        return _vm._l((row5.item.multipleContainerType.split(',')), function(item, index3) {
          return _c('span', {
            key: index3
          }, [_c('h6', [_c('b-badge', {
            attrs: {
              "variant": "light"
            }
          }, [_vm._v(_vm._s(item))])], 1)])
        })
      }
    }, {
      key: "ContainerNo",
      fn: function(row50) {
        return _vm._l((row50.item.ContainerNo.split(',')), function(item1, index3) {
          return _c('span', {
            key: index3
          }, [_c('h6', [_c('b-badge', {
            attrs: {
              "variant": "light"
            }
          }, [_vm._v(_vm._s(item1))])], 1)])
        })
      }
    }, {
      key: "shipLine",
      fn: function(row7) {
        return _vm._l((row7.item.shipLine.split(',')), function(item9, index5) {
          return _c('span', {
            key: index5
          }, [_c('h6', [_c('b-badge', {
            attrs: {
              "variant": "light"
            }
          }, [_vm._v(_vm._s(item9))])], 1)])
        })
      }
    }])
  }), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('b-pagination', {
    attrs: {
      "per-page": _vm.perPageTPT,
      "total-rows": _vm.totalRowsTPT
    },
    on: {
      "change": function($event) {
        _vm.onPageChangeTPT($event)
      }
    },
    model: {
      value: (_vm.currentPageTPT),
      callback: function($$v) {
        _vm.currentPageTPT = $$v
      },
      expression: "currentPageTPT"
    }
  })], 1)], 1) : _vm._e()]), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Transportation"
    }
  }, [_vm._v("Tab Contents 2")]), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Transportation"
    }
  }, [_vm._v("Tab Contents 2")]), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Transportation"
    }
  }, [_vm._v("Tab Contents 2")]), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Transportation"
    }
  }, [_vm._v("Tab Contents 2")])], 1)], 1)], 1)])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-58c8d4e0","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/view/dashboard/dashboardTptReports.vue
// module id = 2656
// module chunks = 0